export default "__VITE_ASSET__e0dbc8cf__"